module.exports = __webpack_public_path__ + "static/media/CG.08a01972.png";